import { ChangeDetectionStrategy, Component, ViewChild, OnInit, ViewEncapsulation, Input,OnDestroy, ChangeDetectorRef, OnChanges, SimpleChanges } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { OneSnackBarService, OneSnackBarType } from '@one/angular-kit/modal';
import { CreateReminderComponent } from '../create-reminder/create-reminder.component';
import { CreateReminderDialogService } from '../create-reminder-dialog.service';
import { QnSbnDataService } from '../../../services/qn-sbn-data-service.service';

@Component({
  selector: 'dl-reminder-table',
  templateUrl: './reminder-table.component.html',
  styleUrls: ['./reminder-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReminderTableComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild(MatSort, { static: true }) public sort: MatSort;
  @Input() public displayedColumns = [];
  @Input() public tableData = [];
  @Input() public isDialogMode: boolean = false;
  @Input() public notificationData: any;
  @Input() public onEditReminder: (editedReminder: any, originalReminder: any) => void;
  @Input() public onDeleteReminder: (reminder: any) => void;
  public dataSource = new MatTableDataSource<any>(this.tableData);
  public selection = new SelectionModel(true, []);
  public selectedRow: any;
  public editRowIndex: number;
  remainderrowval:any;
  private mappingSubscription?: Subscription;
  public constructor(private changeDetectorRef: ChangeDetectorRef,private createReminderDialogService: CreateReminderDialogService,private _QnSbnDataService:QnSbnDataService, private readonly dialog?: MatDialog, private readonly oneSnackBar?: OneSnackBarService) {}
  

  public ngOnInit(): void {
    if (!this.isDialogMode) {
      this.createReminderDialogService.setRemindersDate([]);
      this.mappingSubscription = this._QnSbnDataService.mappingData$.subscribe(observer=>{ 
        if(!this._QnSbnDataService.isEmpty(observer['notificationReminders'])){
          this.updateTableData(observer['notificationReminders']['remindersData']);
        }
      });
    }

    this.updateTableData(this.tableData);
    this.dataSource.sort = this.sort;
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['tableData']) {
      this.updateTableData(changes['tableData'].currentValue);
    }
  }

  private updateTableData(data: any[]): void {
    this.tableData = Array.isArray(data) ? data : [];
    this.dataSource.data = [...this.tableData];
    if (!this.isDialogMode) {
      this.createReminderDialogService.setRemindersDate(this.tableData);
    }
    this.changeDetectorRef.detectChanges();
  }

  public editReminderTemplate(row: any, indx: number): void {
    // Check if reminder is editable
    if (!this.isReminderEditable(row)) {
      this.oneSnackBar.open('Cannot edit reminders that are scheduled for today or in the past', OneSnackBarType.WARNING, '', { duration: 3000 });
      return;
    }

    this.editRowIndex = indx;
    const dialogRef = this.dialog.open(CreateReminderComponent, {
      data: { 
        feedbackDueDate: this.createReminderDialogService.dueDateValue, 
        reminderData: row, 
        remindersData: this.dataSource.data,
        isEdit: true,
        isDialogMode: this.isDialogMode,
        notificationData: this.notificationData
      },
      disableClose: true,
      autoFocus: false,
      panelClass: 'reminder-modalbox'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!result.data) {
        return;
      }
      
      if (this.isDialogMode && this.onEditReminder) {
        // In dialog mode, call the parent's edit API method
        this.onEditReminder(result.data[0], row);
      } else {
        // In regular page mode, update the table directly (original behavior)
        const reminderTable = [...this.dataSource.data];
        // Preserve the reminderId when updating
        const updatedReminder = { ...result.data[0] };
        if (row.reminderId) {
          updatedReminder.reminderId = row.reminderId;
        }
        reminderTable[this.editRowIndex] = updatedReminder;
        this.updateTableData(reminderTable);
        this.addProduct(this.dataSource.data);
        
        // Show success message
        this.oneSnackBar.open('Reminder updated successfully', OneSnackBarType.SUCCESS, '', { duration: 3000 });
      }
    });
  }

  public deleteReminderTemplate(elm: any, index: number): void {
    // Check if reminder is removable
    if (!this.isReminderRemovable(elm)) {
      this.oneSnackBar.open('Cannot delete reminders that are scheduled for today or in the past', OneSnackBarType.WARNING, '', { duration: 3000 });
      return;
    }

    if (this.isDialogMode && this.onDeleteReminder) {
      this.onDeleteReminder(elm);
      return;
    }

    const filtered = this.dataSource.data.filter(item => item !== elm);
    this.updateTableData(filtered);
    this.addProduct(this.dataSource.data);
    this.oneSnackBar.open('Reminder successfully deleted', OneSnackBarType.SUCCESS);
  }

  public isReminderEditable(reminder: any): boolean {
    if (!reminder.reminderDate) return true;
    const reminderDate = new Date(reminder.reminderDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    reminderDate.setHours(0, 0, 0, 0);
    return reminderDate > today;
  }

  public isReminderRemovable(reminder: any): boolean {
    return this.isReminderEditable(reminder);
  }

  public onSendModeChange(value: Event, elm: any, index: number): void {
    this.dataSource.data[index].reminderSendMode = value;
  }
  public addProduct(tData) {    
    if (!this.isDialogMode) {
      this._QnSbnDataService.getMappedQnsbnData({
        "remindersData":tData     
      },"NotificationReminders"); 
    }
    // this.dataSource.data = []
 }
  ngOnDestroy(): void {
   if (!this.isDialogMode) {
     this.addProduct(this.dataSource.data);
   }
   this.mappingSubscription?.unsubscribe();
  }
}
